import { FC, ReactNode } from 'react'
import { useMediaQuery, Typography, Theme } from '@mui/material'
import Link from 'next/link'
import { styled } from '@mui/material/styles'
import { useAuth } from 'src/hooks'
import { Content } from './Content'
import Grid from '@mui/material/Grid2'
import Image from 'next/image'
import { MenuButton } from './MenuButton'

const HeaderContent = styled(Grid)`
  min-height: 71px;
  transition:
    padding-top 0.2s ease-in,
    min-height 0.2s ease-in;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    min-height: 114px;
    padding-top: 12px;
  }

  .sticky-box.-sticked.-stick-to-top & {
    padding-top: 0;
  }
`

const Title = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isLarge',
})<{ isLarge?: boolean }>`
  color: ${({ theme }) => theme.custom.colors.common.black};
  font-weight: 500;
  font-size: ${({ isLarge }) => (isLarge ? '26px' : '18px')};
`

const MobileLogo: FC = () => {
  const { isAuthorized } = useAuth()
  const linkPath = isAuthorized ? '/participant/list' : '/'

  return (
    <Typography sx={{ display: 'flex', px: 1.5, ml: '-12px' }} component={Link} href={linkPath}>
      <Image width={30} height={30} alt="Charleston Wrap Logo" src="/logo-mobile.jpg" />
    </Typography>
  )
}

export interface HeaderProps {
  title: string | ReactNode
  arrowBack?: boolean
  startIcon?: ReactNode
  preEndIcon?: ReactNode
  endIcon?: ReactNode
}

export const Header: FC<HeaderProps> = ({ title, startIcon = null, endIcon = null, preEndIcon = null }) => {
  const isLarge = useMediaQuery<Theme>((theme) => theme.breakpoints.up('sm'))
  const icon = isLarge ? startIcon : startIcon || <MobileLogo />

  return (
    <Content>
      <HeaderContent container justifyContent="space-between" alignItems="center">
        {icon && <Grid>{icon}</Grid>}
        <Grid size={{ xs: 'grow' }}>
          <Title align={isLarge ? 'left' : 'center'} isLarge={isLarge}>
            {title}
          </Title>
        </Grid>
        {endIcon ? (
          <Grid sx={{ transform: isLarge ? 'scale(1.3)' : 'none' }}>{endIcon}</Grid>
        ) : (
          <MenuButton preEndIcon={preEndIcon} />
        )}
      </HeaderContent>
    </Content>
  )
}
